import React, { useContext } from "react";
import {Grid} from "react-flexbox-grid";
import Footer from "../shared/Footer";
import NavBar from "../shared/NavBar";
import TopMenu from "../shared/TopMenu";
import Loader from "../shared/Loader";
import DomainContext from "../../domains/domainPathContext";

const OneColumn = props => {
    const subdomain = useContext(DomainContext);

    const getTabs = () => {
        return !props.hideTopMenu ? (<TopMenu pageConfig={props.pageConfig}/>) : '';
    };

    const getTitle = () => {
        return !props.noTitle ? (
            <Grid className="pT-40 pB-20 title">
                <h2 className="text-justify">
                    { subdomain == 'convocatorias.sedeco' ? 'Bienvenido a tu convocatoria' : 'Bienvenido a tus trámites' }
                </h2>
            </Grid>
        ) : '';
    };

    return (
        <div className="one_column">
            <NavBar {...props} />

            { getTitle() }

            <Grid fluid={true} className="no-padding" style={{minHeight: '76vh'}}>
                { getTabs() }

                <Grid fluid={true} className="principal-container no-padding">
                    <Grid fluid={props.fluid} className={props.fluid ? 'p-0': ''}>{props.children}</Grid>
                </Grid>
            </Grid>

            < Loader/>
            < Footer/>
        </div>
    );
};

export default OneColumn;
